module.exports = __webpack_public_path__ + "img/6.34b5a0a0.jpg";